import defaultLogo from "../assets/logo/logo-hd.png";

const logoAltText = window.__env.LOGO_ALT_TEXT || "Get Move Logo";

type Props = {
  height?: string | number;
  width?: string | number;
  className?: string;
  logo?: string;
};

export default function Logo({ height, width, className, logo }: Props) {
  
  return (
    <img
      alt={logoAltText}
      src={logo || defaultLogo}
      height={height}
      width={width}
      className={className}
    />
  );
}
